module.exports = __webpack_public_path__ + "img/FUE_footer_black.2ee5db66.png";